// extracted by mini-css-extract-plugin
export default {"resume":"Resume_resume__-F9ii","resumeLink":"Resume_resumeLink__InIvy"};